import { Input } from "@vds/inputs";

const UniqueNameInput = ({
  label = "Name",
  onChange,
  dataList,
  error,
  setIsError,
  setIsValid,
  defaultValue,
  isEdit = false,
  value,
  isInitial = false,
  errorText = "Duplicate Alert name found. Please enter a different name.",
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value.trim();
    const isDuplicate = inputValue && dataList?.some((data) => data?.name === inputValue || data?.ruleName === inputValue);
    if (isEdit && isInitial) {
      setIsError(false);
      setIsValid(true);
    } else if (!isInitial && inputValue === value) {
      setIsError(false);
      setIsValid(true);
    } else if (isDuplicate && !isInitial) {
      setIsError(true);
      setIsValid(false);
    } else {
      setIsError(false);
      setIsValid(true);
    }

    onChange(e, "ruleName");
  };

  return (
    <Input
      type="text"
      label={!isEdit && label}
      value={value}
      defaultValue={defaultValue}
      onChange={handleChange}
      error={error}
      errorText={
        value == "" || (!value && !error) ? `Enter ${label}` : errorText
      }
    />
  );
};

export default UniqueNameInput;
